import keyMirror from "ramda-extension/es/keyMirror";
export const authorizeResponseType = 'code';
export const authorizePromptType = keyMirror({
    login: null,
    none: null
});
export const TOKEN_HINT_TYPE = {
    accessToken: 'access_token',
    refreshToken: 'refresh_token'
};
export const TOKEN = keyMirror({
    ACCESS_TOKEN_KEY: null,
    REFRESH_TOKEN_KEY: null
});
export const REVOKE_URL = '/revoke';
export const TOKEN_STORAGE_FLOW = keyMirror({
    LOCAL_STORAGE: null,
    PROMPT: null
});
export const requestUuids = {
    revokeAuthorizationTokens: 'GEF_REVOKE_AUTHORIZATION_TOKENS_REQUEST_ID'
};
export const authorizationErrorCodes = {
    codeRequired: 'code_required',
    loginRequired: 'login_required',
    interactionRequired: 'interaction_required',
    accountSelectionRequired: 'account_selection_required',
    consentRequired: 'consent_required'
};
export const promptRedirectErrors = [
    authorizationErrorCodes.loginRequired,
    authorizationErrorCodes.interactionRequired,
    authorizationErrorCodes.accountSelectionRequired,
    authorizationErrorCodes.consentRequired
];
